<motif-modal-title>
  <h2 class="motif-h3">{{ title }}</h2>
  <motif-icon
    style="padding-right: 0.5rem"
    motif-modal-close
    [src]="'/assets/icons/navigation/ic_close_24px.svg'"
  ></motif-icon>
</motif-modal-title>
<motif-modal-content>
  <p *ngFor="let msg of messages">{{ msg }}</p>
</motif-modal-content>
<motif-modal-actions *ngIf="isActionButtonsRequired">
  <div *ngFor="let button of buttons">
    <button
      motifButton
      [motif-modal-close]="button.returnValue"
      [color]="getButtonColor(button)"
      aria-label="Submit"
      role="button"
      size="fluid"
    >
      {{ button.name }}
    </button>
  </div>
</motif-modal-actions>
